import React from "react";
import bannerImg from "../../../../Assets/Images/bannerTwo.png";
import { motion } from "framer-motion";
import "../AllBanner/technologiesBanner.css";
import { Link } from "react-router-dom";

const BannerTwo = () => {
  return (
    <div
      className="tech-web-banner"
      style={{ backgroundColor: " #0b4f5d", color: "white" }}
    >
      <div
        className="d-flex flex-column flex-md-row justify-content-between align-items-center"
        style={{
          padding: "1rem 0",
          gap: "80px",
          width: "90%",
          margin: "0 auto",
        }}
      >
        {/* Left Text Section */}
        <div
          className="d-flex flex-column justify-content-center"
          style={{
            flex: "1",
            maxWidth: "450px",
          }}
        >
          <h2 className="UI-heading  fw-semibold text-center text-md-start mb-3">
            Design That Reveals Where Users Get Stuck
          </h2>
          <p className="database-text text-center text-md-start small mb-4">
            Good design is evident in the small moments. When a user does not
            have to think twice. When a task is completed faster than
            anticipated. When there is never any confusion. At Quad Theory Ltd,
            UI and UX design is initiated by tracing real user journeys and
            locating the exact places where friction lurks. We reconstruct
            flows, screens and interactions around those moments to ensure that
            products feel calm, predictable and easy to move through, even when
            the system behind them is complicated.
          </p>

          <Link className="mx-auto mx-md-0" to="/contact-us">
            <motion.button
              type="button"
              className=" px-5 py-3 mx-auto mx-md-0  rounded-pill align-self-start"
              initial={{
                backgroundColor: "#19BDDE",
                boxShadow: "0 8px 20px rgba(25, 189, 222, 0.4)",
              }}
              whileHover={{
                backgroundColor: "#12869E",
                // scale: 1.05,
                boxShadow: "none",
              }}
              transition={{ duration: 0.2 }}
              style={{
                border: "none",
                color: "#fff",
                fontWeight: "500",
                fontSize: "1.4rem",
              }}
            >
              Start UI/UX Process
            </motion.button>
          </Link>
        </div>

        {/* Right Image Section */}
        <div style={{ flex: "1", textAlign: "center" }}>
          <img
            src={bannerImg}
            alt="Banner"
            className="img-fluid tech_ui_banner_img"
          />
        </div>
      </div>
    </div>
  );
};

export default BannerTwo;
